export default __webpack_public_path__ + "static/media/order_1.191cbfed.png";